import ephiClient from '@/axiosClients/ephiClient'
import operationClient from '@/axiosClients/operationClient'
import {buildErrorResult} from "@/utils/errorDecodeUtil"
import {downloadFile} from "@/utils/filesUtil"

export const saveMedicalExam = async ({commit}, params) => {
    try {
        const {data: result} = await ephiClient.post(`/patients/admission-medical-exam/${params.patientId}`, params.medicalExam)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}

export const updateMedicalExam = async ({commit}, data) => {
    try {
        const {data: result} = await ephiClient.post(`/patients/admission-medical-exam/${data.patientId}/${data.medicalExamId}`, data.medicalExam)
        const {data: examId, message, error} = result.result
        return {data: examId, message, error}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}

/**
 * Guarda el paso en el que va el médico sin dar el examen por terminado.
 *
 * Va contra el mismo endpoint que el guardado explícito; lo que cambia es save_mode: el servidor no
 * sella la fecha de finalización ni borra los diagnósticos ya capturados. Sin medicalExamId crea el
 * examen y devuelve su id en data.
 */
export const autosaveMedicalExam = async ({commit}, {patientId, medicalExamId, medicalExam}) => {
    try {
        const url = medicalExamId
            ? `/patients/admission-medical-exam/${patientId}/${medicalExamId}`
            : `/patients/admission-medical-exam/${patientId}`
        const {data: result} = await ephiClient.post(url, medicalExam)
        const {data, message, error, saved_ids} = result.result
        //saved_ids trae el id de las filas que el cliente no puede nombrar —una cirugía nueva viaja
        //sin id— para que deje de mandarlas como nuevas en el siguiente guardado.
        return {data, message, error, saved_ids}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}

export const getMedicalExamById = async ({commit}, medicalExamId) => {
    try {
        const {data: result} = await ephiClient.get(`/patients/admission-medical-exam/${medicalExamId}`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}

export const deleteMedicalExamFile = async ({commit}, file_item) => {
    try {
        const {data: result} = await ephiClient.delete(`/patients/admission-medical-exam/file/${file_item.id}`)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}

export const deleteTreatment = async ({commit}, {admission_medical_exams_treatment_id}) => {
    try {
        const {data: result} = await ephiClient.delete(`/patients/admission-medical-exam/treatment/${admission_medical_exams_treatment_id}`)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        return buildErrorResult(ex)
    }
}
